export const getEnvironment = () => {
  const origin = window.location.origin;
  if (
    origin.includes("localhost") ||
    origin.includes("dev") ||
    origin.includes("qa")
  ) {
    return "dev";
  } else if (origin.includes("uat")) {
    return "uat";
  } else if (origin.includes("lgvone.niagarawater")) {
    return "prod";
  }
  return null;
};

export const getDynamicApiLink = () => {
  const env = getEnvironment();
  switch (env) {
    case "dev":
      return process.env.REACT_APP_DEV_POINT;
    case "uat":
      return process.env.REACT_APP_UAT_POINT;
    case "prod":
      return process.env.REACT_APP_PROD_POINT;
    default:
      return null;
  }
};

export const getSocketEndPoint = () => {
  const env = getEnvironment();
  switch (env) {
    case "dev":
      return process.env.REACT_APP_ON_PREM_POINT;
    case "uat":
      return process.env.REACT_APP_ON_PREM_POINT_UAT;
    case "prod":
      return process.env.REACT_APP_PROD_ON_PREM_POINT;
    default:
      return null;
  }
};

export const getBlobStorageEndPoint = (config) => {
  if (config) {
    const {
      AZURE_BLOB_BASE_URL_DEV,
      AZURE_BLOB_BASE_URL_UAT,
      AZURE_BLOB_BASE_URL_PROD
    } = config;
    const env = getEnvironment();
    switch (env) {
      case "dev":
        return AZURE_BLOB_BASE_URL_DEV;
      case "uat":
        return AZURE_BLOB_BASE_URL_UAT;
      case "prod":
        return AZURE_BLOB_BASE_URL_PROD;
      default:
        return null;
    }
  }
};

export const plantConfigUrl = `${getDynamicApiLink()}/config`;
export const plantDetailsAPI = `${window.location.origin}/plantsJSON`;
export const lgvHistoryStatus = `${getDynamicApiLink()}/lgvtraffic`;
export const heatmapDetails = `${getDynamicApiLink()}/heatmapdetails`;
export const blockStorage = `${getDynamicApiLink()}/storages/block?location=`;
export const rackStorage = `${getDynamicApiLink()}/storages/rack?location=`;

//TimeMachine
export const DOCKDOOR_TIMEMACHINE_URL = `${getDynamicApiLink()}/queryexecutor?featureType=DOCK_DOORS`;
export const LGV_TIMEMACHINE_URL = `${getDynamicApiLink()}/queryexecutor?featureType=LGV_MOVEMENTS`;
export const PRODUCTION_LINES_TIMEMACHINE_URL = `${getDynamicApiLink()}/queryexecutor?featureType=PRODUCTION_LINES`;
export const RACK_STORAGES_TIMEMACHINE_URL = `${getDynamicApiLink()}/queryexecutor?featureType=RACK_STORAGES`;
export const BLOCK_STORAGES_TIMEMACHINE_URL = `${getDynamicApiLink()}/queryexecutor?featureType=BLOCK_STORAGES`;
export const MAX_TIMESTAMP_TIMEMACHINE_URL = `${getDynamicApiLink()}/queryexecutor?featureType=MAX_TIMESTAMP_FINDER`;

//Heatmap
export const navHeatmapLevel2 = `${getDynamicApiLink()}/queryexecutor?featureType=AGGREGATED_NAVQ`;
export const navHeatmapLevel3 = `${getDynamicApiLink()}/queryexecutor?featureType=RAW_NAVQ`;
